/**
 * E-Invoice Types
 * E-Fatura için özel tip tanımlamaları
 */

// Fatura Profil Türleri (Invoice Profile Type)
export enum EInvoiceProfileType {
  TEMEL = 'TEMEL',
  TICARIFATURA = 'TICARIFATURA',
  EARSIV = 'EARSIV',
  TEMELFATURA = 'TEMELFATURA',
  IHRACAT = 'IHRACAT',
  YOLCUBERABERFATURA = 'YOLCUBERABERFATURA',
  HKSFATURA = 'HKSFATURA',
  ENERJIFATURA = 'ENERJIFATURA',
  ILACTIBBICIHAZFATURA = 'ILACTIBBICIHAZFATURA',
  YATIRIMTESVIK = 'YATIRIMTESVIK',
}

// Fatura Profil Türü Görünen İsimleri
export const EInvoiceProfileTypeLabels: Record<EInvoiceProfileType, string> = {
  [EInvoiceProfileType.TEMEL]: 'Temel',
  [EInvoiceProfileType.TICARIFATURA]: 'Ticari',
  [EInvoiceProfileType.EARSIV]: 'E-Arşiv',
  [EInvoiceProfileType.TEMELFATURA]: 'Kamu',
  [EInvoiceProfileType.IHRACAT]: 'İhracat',
  [EInvoiceProfileType.YOLCUBERABERFATURA]: 'Yolcu Beraber',
  [EInvoiceProfileType.HKSFATURA]: 'Hal Tipi',
  [EInvoiceProfileType.ENERJIFATURA]: 'Enerji',
  [EInvoiceProfileType.ILACTIBBICIHAZFATURA]: 'İlaç Tıbbi Cihaz',
  [EInvoiceProfileType.YATIRIMTESVIK]: 'Yatırım Teşvik',
};

// Fatura Tip Kodları (Invoice Type Code)
export enum EInvoiceTypeCode {
  SATIS = 'SATIS',
  IADE = 'IADE',
  TEVKIFAT = 'TEVKIFAT',
  TEVKIFATIADE = 'TEVKIFATIADE',
  ISTISNA = 'ISTISNA',
  OZELMATRAH = 'OZELMATRAH',
  IHRACKAYITLI = 'IHRACKAYITLI',
  SGK = 'SGK',
  KOMISYONCU = 'KOMISYONCU',
  KONAKLAMAVERGISI = 'KONAKLAMAVERGISI',
  SARJ = 'SARJ',
  SARJANLIK = 'SARJANLIK',
}

// Fatura Tip Kodu Görünen İsimleri
export const EInvoiceTypeCodeLabels: Record<EInvoiceTypeCode, string> = {
  [EInvoiceTypeCode.SATIS]: 'Satış',
  [EInvoiceTypeCode.IADE]: 'İade',
  [EInvoiceTypeCode.TEVKIFAT]: 'Tevkifat',
  [EInvoiceTypeCode.TEVKIFATIADE]: 'Tevkifat İade',
  [EInvoiceTypeCode.ISTISNA]: 'İstisna',
  [EInvoiceTypeCode.OZELMATRAH]: 'Özel Matrah',
  [EInvoiceTypeCode.IHRACKAYITLI]: 'İhraç Kayıtlı',
  [EInvoiceTypeCode.SGK]: 'SGK',
  [EInvoiceTypeCode.KOMISYONCU]: 'Komisyoncu',
  [EInvoiceTypeCode.KONAKLAMAVERGISI]: 'Konaklama Vergisi',
  [EInvoiceTypeCode.SARJ]: 'Şarj',
  [EInvoiceTypeCode.SARJANLIK]: 'Şarj Anlık',
};

// E-Fatura Senaryo Türleri
export enum EInvoiceScenario {
  TEMEL = 'TEMEL',
  TICARIFATURA = 'TICARIFATURA',
  EARSIV = 'EARSIV',
  TEMELFATURA = 'TEMELFATURA',
  YOLCUBERABERFATURA = 'YOLCUBERABERFATURA',
  IHRACAT = 'IHRACAT',
}

// E-Fatura Kullanıcı Bilgileri (Sorgulama sonucu)
export interface EInvoiceUserInfo {
  etiket: string;           // E-posta etiketi (urn:mail:...)
  unvan: string;            // Şirket ünvanı
  vergiTcKimlikNo: string;  // VKN/TCKN
  kayitZamani: string;      // Kayıt tarihi (YYYYMMDDHHMMSS)
  kamuKurulusu: boolean;    // Kamu kurumu mu?
}

// E-Fatura Sorgulama Cevabı
export interface EInvoiceUserQueryResponse {
  success: boolean;
  eFaturaMukellefMi: boolean;
  sorgulamaYapilan: string;
  toplamKayit: number;
  kullanicilar: EInvoiceUserInfo[];
  error?: string;
}

// E-Fatura Durumu
export enum EInvoiceStatus {
  DRAFT = 'DRAFT',           // Taslak
  PENDING = 'PENDING',       // Gönderilmeyi bekliyor
  SENT = 'SENT',             // GİB'e gönderildi
  DELIVERED = 'DELIVERED',   // Teslim edildi
  REJECTED = 'REJECTED',     // Reddedildi
  CANCELLED = 'CANCELLED',   // İptal edildi
}

// E-Fatura Durum Görünen İsimleri
export const EInvoiceStatusLabels: Record<EInvoiceStatus, string> = {
  [EInvoiceStatus.DRAFT]: 'Taslak',
  [EInvoiceStatus.PENDING]: 'Beklemede',
  [EInvoiceStatus.SENT]: 'Gönderildi',
  [EInvoiceStatus.DELIVERED]: 'Teslim Edildi',
  [EInvoiceStatus.REJECTED]: 'Reddedildi',
  [EInvoiceStatus.CANCELLED]: 'İptal Edildi',
};

// E-Fatura Verisi (Fatura ile birlikte saklanacak)
export interface EInvoiceData {
  profileType: EInvoiceProfileType;
  typeCode: EInvoiceTypeCode;
  scenario: EInvoiceScenario;
  uuid?: string;              // GİB tarafından verilen UUID
  envelopeId?: string;        // Zarf ID
  status: EInvoiceStatus;
  sentDate?: string;          // Gönderim tarihi
  deliveryDate?: string;      // Teslim tarihi
  gibResponse?: any;          // GİB'den gelen cevap
  xml?: string;               // Oluşturulan XML
  recipientAlias?: string;    // Alıcı e-fatura etiketi
}

// Fatura türü ve tipine göre hangi senaryonun kullanılacağı mapping
export const ProfileTypeToScenarioMap: Record<EInvoiceProfileType, EInvoiceScenario> = {
  [EInvoiceProfileType.TEMEL]: EInvoiceScenario.TEMEL,
  [EInvoiceProfileType.TICARIFATURA]: EInvoiceScenario.TICARIFATURA,
  [EInvoiceProfileType.EARSIV]: EInvoiceScenario.EARSIV,
  [EInvoiceProfileType.TEMELFATURA]: EInvoiceScenario.TEMELFATURA,
  [EInvoiceProfileType.IHRACAT]: EInvoiceScenario.IHRACAT,
  [EInvoiceProfileType.YOLCUBERABERFATURA]: EInvoiceScenario.YOLCUBERABERFATURA,
  [EInvoiceProfileType.HKSFATURA]: EInvoiceScenario.TEMEL,
  [EInvoiceProfileType.ENERJIFATURA]: EInvoiceScenario.TEMEL,
  [EInvoiceProfileType.ILACTIBBICIHAZFATURA]: EInvoiceScenario.TEMEL,
  [EInvoiceProfileType.YATIRIMTESVIK]: EInvoiceScenario.TEMEL,
};

